export default __webpack_public_path__ + "static/banner-img-c54aa4c88b9444ae9d1faced2e899e58.png";